import * as z from "zod/v4";

/**
 * Builds the zod schema for a single agenda item variant. Each known item
 * type combines its data fields with the shared envelope (`id`, `type`)
 * via this helper, then registers itself in the discriminated union.
 */
export function defineAgendaItemSchema<
  TType extends string,
  TShape extends z.ZodRawShape,
>(type: TType, shape: TShape) {
  return z.object({ id: z.string(), type: z.literal(type), ...shape });
}
